export default {
	dueDate: 'Due date | Due date in',
	day: 'day | days',
	overdue: 'Overdue',
	today: 'Today',
	now: 'Now',
	onTime: 'On time',
	approaching: 'Approaching',
	critical: 'Critical',
	date: 'Date',
}
